export default defineNuxtRouteMiddleware((to, from) => {
    const hasToken = $cookies.get('apollo-token')
    if (hasToken && to.fullPath !== '/auth/validate-phone') {
      return navigateTo('/')
    }
  })
  